import PopupMask from "@/componentsUI/PopupMask";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import React from "react";
import "./index.less";
import startImage from "../assets/guanxiao1.png";
import backgroundImage from "../assets/guanxiao0.png";
import ButtonUI from "@/componentsUI/Button";
import rotateImage from "../assets/guanxiao2.png";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { useSWRConfig } from "swr";
export interface RedpackSettlementProps {
  amount?: number;
  currency?: string;
}

const RedpackSettlement = NiceModal.create((props: RedpackSettlementProps) => {
  const { t } = useTranslationPlus();
  const { amount, currency } = props;
  const { visible, remove } = useModal();
  const { mutate: musateSuper } = useSWRConfig();
  function onClick() {
    musateSuper("bonusAwardList");
    remove();
  }

  return (
    <PopupMask visible={visible}>
      <div className="redpack-settlement">
        <div className="backgroundImage">
          <img src={backgroundImage} draggable={false} />
        </div>
        <div className="rotateImage">
          <img src={rotateImage} draggable={false} />
        </div>
        <div className="backgroundImage-1">
          <img src={startImage} draggable={false} />
        </div>
        <div className="title">
          <span>{t("redpack.Reward")}</span>
        </div>
        <div className="bottom-button">
          <ButtonUI type={"primary"} onClick={onClick}>
            {t("redpack.collect")}
          </ButtonUI>
        </div>
        <div className="amount-text">
          <span>{`${amount.toFixed(2)}`}</span>
        </div>
      </div>
    </PopupMask>
  );
});

export default RedpackSettlement;
